import { GET_FRAMES_BY_SLUG } from "../../operations/queries/operations/queries/get-frames-by-slug.js";
const getFramesBySlug = async ({ client, slug, locale }) => {
  const queryResult = await client.query({
    query: GET_FRAMES_BY_SLUG,
    variables: { slug },
    context: { headers: { "Accept-Language": locale } }
  });
  return queryResult;
};
export {
  getFramesBySlug
};
//# sourceMappingURL=getFramesBySlug.js.map
